import { render } from "./Formato1957.vue?vue&type=template&id=5887423f&scoped=true"
import script from "./Formato1957.vue?vue&type=script&lang=js"
export * from "./Formato1957.vue?vue&type=script&lang=js"

import "./Formato1957.vue?vue&type=style&index=0&id=5887423f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5887423f"]])

export default __exports__